
import React, { PropTypes } from 'react';

export default class extends React.Component{

	constructor(props){
		super(props)

		this.state = {
			query: '',
			other_company: '',
			date_start: '',
			date_end: '',
			transaction_types: '',
			exemptions: '',
			reset: false
		}
		
	}

	handleChange(property, value){
		if(typeof(value) == typeof(true)){
			value = value;
		}
		else{
			value = value.toLowerCase();	
		}
		var state = Object.assign({}, this.state);
		state[property] = value;
		this.setState(state);
		this.props.onSubmit(state);
	}

	sortByKey(array, key) {
	    return array.sort(function(a, b) {
	        var x = a[key];
	        var y = b[key];

	        if (typeof x == "string")
	        {
	            x = (""+x).toLowerCase(); 
	        }
	        if (typeof y == "string")
	        {
	            y = (""+y).toLowerCase();
	        }

	        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
	    });
	}

	resetForm(){
		document.getElementById("transaction-filter-form").reset();

		this.state = {
			query: '',
			other_company: '',
			date_start: '',
			date_end: '',
			transaction_types: '',
			exemptions: '',
			reset: false
		};

		this.handleChange('reset', true);
	}

	render(){

		var transaction_types = [];
		var transaction_sub_types = [];
		var exemptions = [];
		var filter = this.props.filter;
		let button;
		if(filter.filtering){
			button = <a className="button reset" onClick={this.resetForm.bind(this)}>Reset <span className="fa fa-close"></span></a>
		} else {
			button = null
		}

		for (var key in this.props.transaction_types) {
		    if (this.props.transaction_types.hasOwnProperty(key)){
		        transaction_types.push(this.props.transaction_types[key]);
		    }
		}

		for (var key in this.props.exemptions) {
		    if (this.props.exemptions.hasOwnProperty(key)){
		        exemptions.push(this.props.exemptions[key]);
		    }
		}

		var from = 2001;
		var year = (new Date()).getFullYear() + 1;
		var years = Array.from({length: year - from}, (_, i) => from + i);

		// flip the order
		years = years.reverse();


		return (
			<div className="form-wrap">
			<form id="transaction-filter-form" onSubmit={e => e.preventDefault()}>

				<h6 className="blue_text">Filter transactions</h6>
				{button}

				<fieldset>
					<div className="field text title">
						<label htmlFor="query">Code Company</label>
						<div className="middleColumn">
							<input 
								name="query" 
								className="text" 
								type="text" 
								placeholder="Start typing..."
								onChange={e => this.handleChange('query', e.target.value)}
							/>
						</div>
					</div>
					<div className="field text other_company">
						<label htmlFor="other_comapny">Offeror or Other Party</label>
						<div className="middleColumn">
							<input 
								name="other_comapny" 
								className="text" 
								type="text" 
								placeholder="Start typing..."
								onChange={e => this.handleChange('other_company', e.target.value)}
							/>
						</div>
					</div>
					<div className="field text date start">
						<label>Year</label>
						<div className="middleColumn">
							<select
								name="date_start"
								onChange={e => this.handleChange('date_start', e.target.value)}>
								<option value="">Any</option>
								{
									years.map(year => {
										return <option key={year} value={year}>{year}</option>
									})
								}
							</select>
						</div>
					</div>
					<div className="field dropdown">
						<label htmlFor="transaction_types">Transaction Type</label>
						<div className="middleColumn">
							<select 
								name="transaction_types"
								onChange={e => this.handleChange('transaction_types', e.target.value)}>
									<option value="">All types</option>
									{
										transaction_types.map(transaction_type => {
											return (
												<option key={transaction_type.ID} value={transaction_type.ID} dangerouslySetInnerHTML={{ __html: transaction_type.Title }}></option>
											);
										})
									}
							</select>
						</div>
					</div>
					<div className="field dropdown exemptions last">
						<label htmlFor="exemptions">Exemptions</label>
						<div className="middleColumn">
							<select 
								name="exemptions"
								onChange={e => this.handleChange('exemptions', e.target.value)}>
									<option value="">Any</option>
									{
										exemptions.map(exemption => {
											return (
												<option key={exemption.ID} value={exemption.ID}>{exemption.Title}</option>
											);
										})
									}
							</select>
						</div>
					</div>
				</fieldset>

			</form>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./site/js/components/TransactionsForm.js